export const understandingEnergyImbalances = {
    heading: "Understanding Energy Imbalances",
    content: [
        '"Everything is energy." Every thought, emotion, and experience carries its own vibrational frequency.',
        'When certain experiences create trapped emotions or energetic imbalances, they can disrupt the natural flow of energy through the body.',
        'These blockages may show up as physical discomfort, emotional distress, or challenges in attracting love, abundance, and overall well-being.',
    ],
}